export function calculatePercent(from, to) {
  return Math.floor((from / to) * 100)
}
